import { SxProps, Theme } from '@mui/material/styles';

export const serviceQueueStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    header: {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { sm: 'flex-start' },
        gap: 2,
    } satisfies SxProps<Theme>,
    filterBar: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    searchField: {
        maxWidth: 280,
    } satisfies SxProps<Theme>,
    statusControl: {
        minWidth: 200,
    } satisfies SxProps<Theme>,
    loading: {
        display: 'flex',
        justifyContent: 'center',
        py: 8,
    } satisfies SxProps<Theme>,
    tableContainer: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
    } satisfies SxProps<Theme>,
    tableHeaderRow: {
        bgcolor: 'grey.50',
    } satisfies SxProps<Theme>,
    tableHeadCell: {
        fontWeight: 600,
    } satisfies SxProps<Theme>,
    emptyRowCell: {
        py: 6,
        color: 'text.secondary',
    } satisfies SxProps<Theme>,
    clickableRow: {
        textDecoration: 'none',
        cursor: 'pointer',
    } satisfies SxProps<Theme>,
    machineCellContent: {
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    thumbnailFrame: {
        width: 48,
        height: 48,
        borderRadius: 1,
        overflow: 'hidden',
        flexShrink: 0,
        bgcolor: 'grey.100',
    } satisfies SxProps<Theme>,
    thumbnailFallback: {
        width: 48,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    } satisfies SxProps<Theme>,
    customerCellContent: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    plannedFinishLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    } satisfies SxProps<Theme>,
};
